import React from "react";
import "./about.css";

function About() {
  return (
    <div className="abt">
      <div className="cnt">
        <div className="about-left">
          <h2>About</h2>
          <hr></hr>
          <p className="card">
          <h4>ABOUT NSS</h4>
            
            <div className="div">
            <ul>
            <li>CMRIT NSS unit, affiliated to JNTU Hyderabad. This unit was
              established in September 2008.</li>
            <li>
            CMRIT has 2 actively functioning units namely:<br></br>
              <ul>
                <li>UNIT - I</li>
                <li>UNIT - II</li>
              </ul>
            </li>
            <li>
            At CMRIT, the Management, Staff and Students actively
              participate in various programs. CMRIT has nearly about 200
              active NSS volunteers.
            </li>
              </ul>
            </div>
            <h4>OUR MOTTO:</h4>
            
            <div className="div">
            <div className="motoo">“NOT ME, BUT YOU”</div>
            <ul>
              <li>The main motto of the National Service Scheme (N.S.S.) is "Not Me, But You". It expresses the essence of 
              democratic living and upholds the need for selfless services and appreciation of another man's point of view 
              and also show consideration towards fellow human beings.</li>
              <li>It underlines the welfare of an individual most necessary as is ultimately leads to the welfare of the 
              society as a whole. Therefore the N.S.S. should aim to demonstrate this motto in itsday-to-day activities.</li>
            </ul>
            </div>
            <h4>OBJECTIVE: </h4>
            
            <div className="div">
            <ul>
              <li>
              The main objective of the National Service Scheme is Personality Development through social service or 
              community service.
              </li>
              <li>
              This program aim at inculcating social welfare thoughts among the students by providing service to society without any
              prejudice.
              </li>
            </ul>
            </div>
            <h4>NSS STUDENT VOLUNTEER SELECTION CRITERIA:</h4>
            
            <div className="div">
              <li>Should have passion towards Social Service</li>
              <li>Possesses good conduct and regular to academics</li>
              <li>Good academic track record</li>
              
            </div>
            <h4>BENEFITS TO STUDENTS: </h4>
           
            <div className="div">
              <li>National Service Scheme (NSS) is beneficial to both students as well as the society in various different means</li>
              <li>NSS helps the student to grow individually and also as a group</li>
              <li>It makes the students confident, develop leadership skills, and gain knowledge about different people from
              different walks of life</li>
              <li>It makes the students confident, develop leadership skills, and gain knowledge about different people from
              different walks of life</li>
              <li>Students also learn other skills that help them lead a better life in various situations</li>
              <li>It teaches you to be disciplined and organized with the objectives you set for yourself and your goals</li>
              
              
            </div>
          </p>
        </div>
        <div className="about-right"></div>
      </div>
    </div>
  );
}

export default About;
